import axios from '../config/axios';
import { notification } from 'antd';
import {getResponseHandler,header} from './commonService'

const category = {

   getCategoryById : async (id = {}) => {
      try{
          const rowData = await axios.get('/category/'+id,header())
          const response = await rowData;
          return getResponseHandler(response);               
      }catch (error){
          console.error(error);
          notification.error({ message: error.message });
      }
   },
   

   getCategorylist : async (data = {}) => {
      try{
          const rowData = await axios.get('/category/',{params:data})
          const response = await rowData;
          return getResponseHandler(response);               
      }catch (error){
          console.error(error);
          notification.error({ message: error.message });
      }
   },

   addCategory : async (data = {}) => {
      try{
          const rowData = await axios.post('/category',header(data))
          const response = await rowData;
          return getResponseHandler(response);               
      }catch (error){
          console.error(error);
          notification.error({ message: error.message });
      }
   },
   deleteCategory: async (id) => {
        try{
            const rowData = await axios.delete('/category/'+id,header())
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message, placement:'bottomRight' });
        }
    },

   changeStatusCategory : async (data = {}) => {
        try{
            const rowData = await axios.post('/category/statusChange',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
    },

    getSubCategorylist : async (data = {}) => {
        try{
            const rowData = await axios.post('/category/subcategory',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
     },
     updateAvgPrice : async (data = {}) => {
        try{
            const rowData = await axios.post('/category/updateAvgPrice',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
     },
     updateMinMaxPrice : async (data = {}) => {
        try{
            const rowData = await axios.post('/category/updateMinMaxPrice',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
     },
     updateSettings : async (data = {}) => {
        try{
            const rowData = await axios.post('/settings/updateSetting',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
     },
     getSettings : async (data = {}) => {
        try{
            const rowData = await axios.get('/settings/getsettings',header(data))
            const response = await rowData;
            return getResponseHandler(response);               
        }catch (error){
            console.error(error);
            notification.error({ message: error.message });
        }
     },
}


export default category